<script setup lang="ts">
import type { Schemas } from "#shopware";

const props = defineProps<{
  crossSelling: Schemas["CrossSellingElement"];
  quantity: number;
}>();

const { crossSelling, quantity } = toRefs(props);

const emits = defineEmits<{
  (
    e: "select",
    product: {
      id: string | undefined;
      quantity: number;
      cover: Schemas["Media"] | undefined;
      productNumber: string;
      name: string;
      unitPrice: number | undefined;
      type: string;
    }
  ): void;
  (e: "remove", id: string): void;
}>();

const addProduct = (product: any) => {
  emits("select", product);
};

const removeItem = (id: string) => {
  emits("remove", id);
};

const { product } = useProduct();

const isServiceCrossSelling = computed(() =>
  crossSelling.value.products.some(
    (p) => p.translated?.customFields?.custom_bundle_type === "service"
  )
);

const isCleanerCrossSelling = computed(() =>
  crossSelling.value.products.some(
    (p) => p.translated?.customFields?.custom_bundle_type === "liquid"
  )
);

const hidePrice = computed(
  () =>
    product.value?.translated?.customFields?.custom_product_fields_hide_price
);
</script>
<template>
  <div>
    <h4 class="font-bold text-base mb-5">
      {{ crossSelling.crossSelling.translated.name }}
    </h4>
    <div
      v-if="isServiceCrossSelling"
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 laptop:grid-cols-5 mb-10 prose-h4:font-bold prose-h4:text-base prose-img:max-w-[4rem]"
    >
      <template v-for="product in crossSelling.products">
        <div>
          <ProductDetailConfigurationServiceItem
            :product="product"
            :quantity="quantity"
            :hide-price="hidePrice"
            @select="addProduct"
            @remove="removeItem"
          />
        </div>
      </template>
    </div>
    <div
      v-else-if="isCleanerCrossSelling"
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 text-center"
    >
      <template v-for="product in crossSelling.products">
        <ProductDetailConfigurationCleanerItem
          :product="product"
          :quantity="quantity"
          :hide-price="hidePrice"
          @select="addProduct"
          @remove="removeItem"
        />
      </template>
    </div>
    <div
      v-else
      class="relative mb-5 [&>.group:not(:last-child)]:border-b overflow-hidden"
    >
      <template v-for="product in crossSelling.products">
        <ProductDetailConfigurationItem
          :product="product"
          :quantity="quantity"
          :hide-price="hidePrice"
          @select="addProduct"
          @remove="removeItem"
        />
      </template>
    </div>
  </div>
</template>
